import { Toaster } from "components";

import { userManagementConstants } from '../constants';

import { func_validation, func_serviceHandling } from 'functions';

import { promiseInstance_authorization } from './config';



export const userManagementActions = {
	getUserList,
	getUserGroupList,
	getUserGroupPermissionList,
	getUserGroupPermission,

	addUser,
	updateUser,
	deleteUser,

	addUserGroup,
	deleteUserGroup,

	addUserGroupMapping,
	removeUserGroupMapping,

	addPermission,
	removePermission,
};

function getUserList(pageNo, pageSize, sort, filterOptions) {
    return dispatch => {
		dispatch(request());

		let isOffsetValid = func_validation.isNumberValid(pageNo) && func_validation.isNumberValid(pageSize);
		let offset = isOffsetValid? pageNo * pageSize:0;

		let username = func_validation.getObjectPropertyValue(filterOptions, "username","");
		let role = func_validation.getObjectPropertyValue(filterOptions, "role","");
		
		let paramObj = {
			offset: offset,
			limit: pageSize,
			sort: sort,
			userSelected: username,
			userRoleSelected: role
		}

		let url = func_serviceHandling.createUrlWithParams('/User/GetListOfUser', paramObj);

		promiseInstance_authorization(dispatch, request, (axios) => {
			axios.get(url)
				.then(function (details) {
					// handle success
					dispatch(success(details));
				})
				.catch(function (error) {
					// handle error
					dispatch(failure(error));
				})
				.finally(function () {
					// always executed
				});
		})
    }

    function request(details) { return { type: userManagementConstants.getUserList_request, details }; }
    function success(details) { return { type: userManagementConstants.getUserList_success, details }; }
    function failure(error) { return { type: userManagementConstants.getUserList_failure, error }; }
}

function getUserGroupList(pageNo, pageSize, sort, filterOptions) {
    return dispatch => {
		dispatch(request());

		let isOffsetValid = func_validation.isNumberValid(pageNo) && func_validation.isNumberValid(pageSize);
		let offset = isOffsetValid? pageNo * pageSize:0;

		let paramObj = {
			offset: offset,
			limit: pageSize,
			sort: sort,
		}

		let url = func_serviceHandling.createUrlWithParams('/User/GetUserGroup', paramObj);

		promiseInstance_authorization(dispatch, request, (axios) => {
			axios.get(url)
				.then(function (details) {
					// handle success
					dispatch(success(details));
				})
				.catch(function (error) {
					// handle error
					dispatch(failure(error));
				})
				.finally(function () {
					// always executed
				});
		})
    }

    function request(details) { return { type: userManagementConstants.getUserGroupList_request, details }; }
    function success(details) { return { type: userManagementConstants.getUserGroupList_success, details }; }
    function failure(error) { return { type: userManagementConstants.getUserGroupList_failure, error }; }
}

function getUserGroupPermissionList(pageNo, pageSize, sort, filterOptions) {
	return dispatch => {
		dispatch(request());

		let isOffsetValid = func_validation.isNumberValid(pageNo) && func_validation.isNumberValid(pageSize);
		let offset = isOffsetValid? pageNo * pageSize:0;

		let paramObj = {
			offset: offset,
			limit: pageSize,
			sort: sort,
		}

		let url = func_serviceHandling.createUrlWithParams('/User/GetAllListOfPermission', paramObj);

		promiseInstance_authorization(dispatch, request, (axios) => {
			axios.get(url)
				.then(function (details) {
					// handle success
					dispatch(success(details));
				})
				.catch(function (error) {
					// handle error
					dispatch(failure(error));
				})
				.finally(function () {
					// always executed
				});
		})
    }

    function request(details) { return { type: userManagementConstants.getUserGroupPermissionList_request, details }; }
    function success(details) { return { type: userManagementConstants.getUserGroupPermissionList_success, details }; }
    function failure(error) { return { type: userManagementConstants.getUserGroupPermissionList_failure, error }; }
}

function getUserGroupPermission(username) {
	return dispatch => {
		dispatch(request());

		let username_validated = func_validation.isStringTrimNotEmpty(username)? username:null;

		promiseInstance_authorization(dispatch, request, (axios) => {
			axios.get('/User/GetAllListOfPermission?userNameSelected=' + username_validated)
				.then(function (details) {
					// handle success
					dispatch(success(details));
				})
				.catch(function (error) {
					// handle error
					dispatch(failure(error));
				})
				.finally(function () {
					// always executed
				});
		})
    }

    function request(details) { return { type: userManagementConstants.getUserGroupPermission_request, details }; }
    function success(details) { return { type: userManagementConstants.getUserGroupPermission_success, details }; }
    function failure(error) { return { type: userManagementConstants.getUserGroupPermission_failure, error }; }
}

function addUser(userInfo, userGroupList) {
    return dispatch => {
		dispatch(request());

		let userInfo_validated = func_validation.isObjectNotEmpty(userInfo)? userInfo: {};

		promiseInstance_authorization(dispatch, request, (axios) => {
			axios.post('/User/RegisterUser', JSON.stringify(userInfo_validated))
				.then(function (details) {
					// handle success

					// Add user group to newly created user
					if (func_validation.isArrayNotEmpty(userGroupList)) {
						promiseInstance_authorization(dispatch, request, (axios) => {
							axios.post('/User/AddUserGroupMapping', JSON.stringify(userGroupList))
								.then(function (details) {
									// handle success
									dispatch(success(details));
									Toaster({ type: "success", msg: "Successfully added user"});
								})
								.catch(function (error) {
									// handle error
									dispatch(failure(error));

									let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Successfully added user, but failed to add user group";
									Toaster({ type: "error", msg });
								})
								.finally(function () {
									// always executed
								});
						})	
					}
					else {
						dispatch(success(details));
						Toaster({ type: "success", msg: "Successfully added user"});
					}
				})
				.catch(function (error) {
					// handle error
					dispatch(failure(error));
					
					let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to add user";
					Toaster({ type: "error", msg });
				})
				.finally(function () {
					// always executed
				});
		})
    }

    function request(details) { return { type: userManagementConstants.addUser_request, details }; }
    function success(details) { return { type: userManagementConstants.addUser_success, details }; }
    function failure(error) { return { type: userManagementConstants.addUser_failure, error }; }
}

function updateUser(userInfo, userGroupList) {
    return dispatch => {
		dispatch(request());

		let userInfo_validated = func_validation.isObjectNotEmpty(userInfo)? userInfo: {};

		promiseInstance_authorization(dispatch, request, (axios) => {
			axios.post('/User/UpdateUser', JSON.stringify(userInfo_validated))
				.then(function (details) {
					// handle success

					// Add user group to newly created user
					if (func_validation.isObjectNotEmpty(userGroupList)) {
						promiseInstance_authorization(dispatch, request, (axios) => {
							axios.post('/User/AddUserGroupMapping', JSON.stringify(userGroupList))
								.then(function (details) {
									// handle success
									dispatch(success(details));
									Toaster({ type: "success", msg: "Successfully updated user"});
								})
								.catch(function (error) {
									// handle error
									dispatch(failure(error));

									let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Successfully updated user, but failed to update user group";
									Toaster({ type: "error", msg });
								})
								.finally(function () {
									// always executed
								});
						})
					}
					else {
						dispatch(success(details));
						Toaster({ type: "success", msg: "Successfully added user"});
					}
				})
				.catch(function (error) {
					// handle error
					dispatch(failure(error));

					let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to update user";
					Toaster({ type: "error", msg });
				})
				.finally(function () {
					// always executed
				});
		})
    }

    function request(details) { return { type: userManagementConstants.updateUser_request, details }; }
    function success(details) { return { type: userManagementConstants.updateUser_success, details }; }
    function failure(error) { return { type: userManagementConstants.updateUser_failure, error }; }
}

function deleteUser(userId) {
    return dispatch => {
		dispatch(request());
		
		let userId_formatted = "";
		if (func_validation.isNotNullUndefined(userId)) 
			userId_formatted = encodeURI(userId);

        promiseInstance_authorization(dispatch, request, (axios) => {
			axios.delete('/User/DeleteUser/' + userId_formatted)
				.then(function (details) {
					// handle success
					dispatch(success(details));
					Toaster({ type: "success", msg: "Successfully deleted user"});
				})
				.catch(function (error) {
					// handle error
					dispatch(failure(error));

					let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to delete user";
					Toaster({ type: "error", msg });
				})
				.finally(function () {
					// always executed
				});
		})
    }

    function request(details) { return { type: userManagementConstants.deleteUser_request, details }; }
    function success(details) { return { type: userManagementConstants.deleteUser_success, details }; }
    function failure(error) { return { type: userManagementConstants.deleteUser_failure, error }; }
}

function addUserGroup(groupNameList, userList, permissionList) {
    return dispatch => {
		dispatch(request());

		let groupNameList_validated = func_validation.isArrayNotEmpty(groupNameList)? groupNameList: [];

		promiseInstance_authorization(dispatch, request, (axios) => {
			axios.post('/User/AddUserGroup', JSON.stringify(groupNameList_validated))
				.then(function (details) {
					let userGroupID = func_validation.getObjectPropertyValue(details?.data[0], "ID");

					// handle success
					let userList_validated = [];
					if (func_validation.isArrayNotEmpty(userList)) {
						userList.map((username) => {
							if (func_validation.isStringTrimNotEmpty(username)) {
								let obj = {};
								obj["ID"] = 0;
								obj["UserName"] = username;
								obj["UserGroupId"] = userGroupID;
								
								userList_validated.push(obj);
							}
						})
					}

					// Add user group to newly created user
					if (func_validation.isArrayNotEmpty(userList_validated)) {
						dispatch(addUserGroupMapping(userList_validated, {
							isSuccessToasterHidden: true,
							customMsg_failure: "Successfully added user group, but failed to add user.",
							callback_success: () => {
								let permissionList_validated = [];
								if (func_validation.isArrayNotEmpty(permissionList)) {
									permissionList.map((permission) => {
										if (func_validation.isStringTrimNotEmpty(permission)) {
											let obj = {};
											obj["ID"] = 0;
											obj["PermissionName"] = permission;
											obj["UserGroupId"] = userGroupID;
											
											permissionList_validated.push(obj);
										}
									})
								}
	
								if (func_validation.isArrayNotEmpty(permissionList_validated)) {
									dispatch(addPermission(permissionList_validated, {
										customMsg_success: "Successfully added user group.",
										customMsg_failure: "Successfully added user group, but failed to add permission.",
										callback_success: (details) => dispatch(success(details)),
										callback_failure: (error) => dispatch(failure(error))
									}))
								}
								else {
									dispatch(success(details));
									Toaster({ type: "success", msg: "Successfully added user group"});
								}
							},
							callback_failure: (error) => dispatch(failure(error))
						}))
					}
					else {
						let permissionList_validated = [];
						if (func_validation.isArrayNotEmpty(permissionList)) {
							permissionList.map((permission) => {
								if (func_validation.isStringTrimNotEmpty(permission)) {
									let obj = {};
									obj["ID"] = 0;
									obj["PermissionName"] = permission;
									obj["UserGroupId"] = userGroupID;
									
									permissionList_validated.push(obj);
								}
							})
						}

						if (func_validation.isArrayNotEmpty(permissionList_validated)) {
							dispatch(addPermission(permissionList_validated, {
								customMsg_success: "Successfully added user group.",
								customMsg_failure: "Successfully added user group, but failed to add permission.",
								callback_success: (details) => dispatch(success(details)),
								callback_failure: (error) => dispatch(failure(error))
							}))
						}
						else {
							dispatch(success(details));
							Toaster({ type: "success", msg: "Successfully added user group"});
						}
					}
				})
				.catch(function (error) {
					// handle error
					dispatch(failure(error));

					let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to add user group";
					Toaster({ type: "error", msg });
				})
				.finally(function () {
					// always executed
				});
		})
    }

    function request(details) { return { type: userManagementConstants.addUserGroup_request, details }; }
    function success(details) { return { type: userManagementConstants.addUserGroup_success, details }; }
    function failure(error) { return { type: userManagementConstants.addUserGroup_failure, error }; }
}

function deleteUserGroup(userId) {
    return dispatch => {
		dispatch(request());
		
		let userId_formatted = "";
		if (func_validation.isNotNullUndefined(userId)) 
			userId_formatted = encodeURI(userId);

        promiseInstance_authorization(dispatch, request, (axios) => {
			axios.delete('/User/DeleteUserGroup/' + userId_formatted)
				.then(function (details) {
					// handle success
					dispatch(success(details));
					Toaster({ type: "success", msg: "Successfully deleted user group"});
				})
				.catch(function (error) {
					// handle error
					dispatch(failure(error));
					
					let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to delete user group";
					Toaster({ type: "error", msg });
				})
				.finally(function () {
					// always executed
				});
		})
    }

    function request(details) { return { type: userManagementConstants.deleteUserGroup_request, details }; }
    function success(details) { return { type: userManagementConstants.deleteUserGroup_success, details }; }
    function failure(error) { return { type: userManagementConstants.deleteUserGroup_failure, error }; }
}

function addUserGroupMapping(list, options) {
	let isSuccessToasterHidden = func_validation.getObjectPropertyValue(options, "isSuccessToasterHidden");
	let customMsg_success = func_validation.getObjectPropertyValue(options, "customMsg_success");
	let isFailureToasterHidden = func_validation.getObjectPropertyValue(options, "isFailureToasterHidden");
	let customMsg_failure = func_validation.getObjectPropertyValue(options, "customMsg_failure");
	let callback_success = func_validation.getObjectPropertyValue(options, "callback_success");
	let callback_failure = func_validation.getObjectPropertyValue(options, "callback_failure");

	let list_validated = func_validation.isArrayNotEmpty(list)? list: [];

    return dispatch => {
		dispatch(request());

		promiseInstance_authorization(dispatch, request, (axios) => {
			axios.post('/User/AddUserGroupMapping', JSON.stringify(list_validated))
				.then(function (details) {
					// handle success
					dispatch(success(details));

					if (func_validation.isFunction(callback_success)) 
						callback_success(details);

					if (!isSuccessToasterHidden) {
						let msg = "Successfully added user group";
						if (func_validation.isStringTrimNotEmpty(customMsg_success))
							msg = customMsg_success;
						Toaster({ type: "success", msg: msg});
					}
				})
				.catch(function (error) {
					// handle error
					dispatch(failure(error));

					if (func_validation.isFunction(callback_failure)) 
						callback_failure(error);

					if (!isFailureToasterHidden) {

						let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: (customMsg_failure? customMsg_failure: "Failed to add user group");
						Toaster({ type: "error", msg });
					}
				})
				.finally(function () {
					// always executed
				});
		})
    }

    function request(details) { return { type: userManagementConstants.addUserGroupMapping_request, details }; }
    function success(details) { return { type: userManagementConstants.addUserGroupMapping_success, details }; }
    function failure(error) { return { type: userManagementConstants.addUserGroupMapping_failure, error }; }
}

function removeUserGroupMapping(userGroupId) {
    return dispatch => {
		dispatch(request());

		let userGroupId_validated = func_validation.isNotNullUndefined(userGroupId)? userGroupId:"";

        promiseInstance_authorization(dispatch, request, (axios) => {
			axios.delete('/User/DeleteUserGroupMapping/' + userGroupId_validated)
				.then(function (details) {
					// handle success
					dispatch(success(details));
					Toaster({ type: "success", msg: "Successfully removed user group"});
				})
				.catch(function (error) {
					// handle error
					dispatch(failure(error));

					let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to remove user group";
					Toaster({ type: "error", msg });
				})
				.finally(function () {
					// always executed
				});
		})
    }

    function request(details) { return { type: userManagementConstants.removeUserGroupMapping_request, details }; }
    function success(details) { return { type: userManagementConstants.removeUserGroupMapping_success, details }; }
    function failure(error) { return { type: userManagementConstants.removeUserGroupMapping_failure, error }; }
}

function addPermission(list, options) {
	let isSuccessToasterHidden = func_validation.getObjectPropertyValue(options, "isSuccessToasterHidden");
	let customMsg_success = func_validation.getObjectPropertyValue(options, "customMsg_success");
	let isFailureToasterHidden = func_validation.getObjectPropertyValue(options, "isFailureToasterHidden");
	let customMsg_failure = func_validation.getObjectPropertyValue(options, "customMsg_failure");
	let callback_success = func_validation.getObjectPropertyValue(options, "callback_success");
	let callback_failure = func_validation.getObjectPropertyValue(options, "callback_failure");

	let list_validated = func_validation.isArrayNotEmpty(list)? list: [];

    return dispatch => {
		dispatch(request());

		promiseInstance_authorization(dispatch, request, (axios) => {
			axios.post('/User/AddPermission', JSON.stringify(list_validated))
				.then(function (details) {
					// handle success
					dispatch(success(details));

					if (func_validation.isFunction(callback_success)) 
						callback_success(details);

					if (!isSuccessToasterHidden) {
						let msg = "Successfully added permission";
						if (func_validation.isStringTrimNotEmpty(customMsg_success))
							msg = customMsg_success;
						Toaster({ type: "success", msg: msg});
					}
				})
				.catch(function (error) {
					// handle error
					dispatch(failure(error));

					if (func_validation.isFunction(callback_failure)) 
						callback_failure(error);

					if (!isFailureToasterHidden) {

						let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: (customMsg_failure? customMsg_failure: "Failed to add permission");
						Toaster({ type: "error", msg });
					}
				})
				.finally(function () {
					// always executed
				});
		})
    }

    function request(details) { return { type: userManagementConstants.addPermission_request, details }; }
    function success(details) { return { type: userManagementConstants.addPermission_success, details }; }
    function failure(error) { return { type: userManagementConstants.addPermission_failure, error }; }
}

function removePermission(list) {
    return dispatch => {
		dispatch(request());

		let list_validated = func_validation.isArrayNotEmpty(list)? list:"";

        promiseInstance_authorization(dispatch, request, (axios) => {
			axios.post('/User/DeletePermission', JSON.stringify(list_validated))
				.then(function (details) {
					// handle success
					dispatch(success(details));
					Toaster({ type: "success", msg: "Successfully removed permission(s)"});
				})
				.catch(function (error) {
					// handle error
					dispatch(failure(error));

					let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to remove permission(s)";
					Toaster({ type: "error", msg });
				})
				.finally(function () {
					// always executed
				});
		})
    }

    function request(details) { return { type: userManagementConstants.removePermission_request, details }; }
    function success(details) { return { type: userManagementConstants.removePermission_success, details }; }
    function failure(error) { return { type: userManagementConstants.removePermission_failure, error }; }
}